'use strict';

/**
 * Loads content from the specified URL and updates the specified container with the retrieved data.
 *
 * @param {jQuery} $button - The element that triggers the content loading.
 * @param {jQuery} $container - The container element where the loaded content will be inserted.
 */
function loadContent($button, $container) {
    const url = $button.data('action');

    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            $container.empty().html(data.template);
        }
    });
}

$(() => {
    /**
     * Selects the folder section (buttons) to load its own dropdown.
     */
    $('body').on('click', '.folder-sections .btn', (e) => {
        let $button = $(e.currentTarget);
        let $container = $('.folder-content');

        $('.folder-sections .btn').removeClass('active');
        $button.addClass('active');

        loadContent($button, $container);
    });

    /**
     * Selects a content asset to display in the content area from the selected dropdown.
     */
    $('body').on('change', '.subfolder-select', (e) => {
        e.preventDefault();
        let $select = $(e.currentTarget);
        let $option = $select.find('option:selected');
        let $container = $('.alimerka-responde-container').find('.content');

        loadContent($option, $container);
    });
});
